import './style.css';
import { Game } from './game/game';
import level11 from './levels/level11.json';
import level12 from './levels/level12.json';
import type { LevelDef } from './world/leveldata';

const canvas = document.querySelector<HTMLCanvasElement>('#screen');
const stage = document.querySelector<HTMLElement>('#stage');
const overlay = document.querySelector<HTMLElement>('#overlay');
const touch = document.querySelector<HTMLElement>('#touch');

if (!canvas || !stage || !overlay || !touch) {
  throw new Error('Sunrise Vale: required DOM nodes are missing from index.html');
}

const levels = [level11, level12] as unknown as LevelDef[];

const game = new Game(canvas, stage, overlay, touch, levels);
game.run();

// Handy for poking at the game from the console while tuning.
(window as unknown as { game: Game }).game = game;
